import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Chip } from "@mui/material";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
} from "@mui/x-data-grid";

import DataTableDefault from "../../../../../components/DataTable";
import { Currency } from "../../../../../types/currency";
import { hasClaim } from "../../../../../storage/userClaims";

interface DataTableProps {
  onEditCurrency: (id: number | string) => void;
  onDeleteCurrency: (id: number | string) => void;
  onViewCurrency: (id: number | string) => void;
  data: Currency[];
  [x: string]: any;
}
export default function DataTable({
  onEditCurrency,
  onDeleteCurrency,
  onViewCurrency,
  data,
  userValidation,
  ...props
}: DataTableProps) {
  const renderMenus = (row: any) => {
    return [
      <GridActionsCellItem
        sx={{
          display:
            hasClaim("Currency - Maintenance") ||
            hasClaim("Currency - Visualization")
              ? "block"
              : "none",
        }}
        key={`view-${row.ID_MOEDA}`}
        icon={<VisibilityIcon />}
        label="View"
        onClick={() => onViewCurrency(row.ID_MOEDA)}
        color="inherit"
        data-testid="view-button"
      />,
      <GridActionsCellItem
        sx={{ display: hasClaim("Currency - Maintenance") ? "block" : "none" }}
        key={`edit-${row.ID_MOEDA}`}
        icon={<EditIcon />}
        label="Edit"
        className="textPrimary"
        onClick={() => onEditCurrency(row.ID_MOEDA)}
        color="inherit"
        data-testid="edit-button"
      />,
      <GridActionsCellItem
        sx={{ display: hasClaim("Currency - Maintenance") ? "block" : "none" }}
        key={`delete-${row.ID_MOEDA}`}
        icon={<DeleteIcon />}
        label="Delete"
        onClick={() => onDeleteCurrency(row.ID_MOEDA)}
        color="inherit"
        data-testid="delete-button"
      />,
    ];
  };

  const columns: GridColDef[] = [
    {
      field: "SIGLA_MOEDA",
      headerName: "Currency",
      headerClassName: "super-app-theme--header",
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridRenderCellParams<any>) => {
        return `${params.row.SIGLA_MOEDA} - ${params.row.DSC_MOEDA}`;
      },
    },
    {
      field: "ATIVO",
      headerName: "Status",
      headerClassName: "super-app-theme--header",
      flex: 1,
      renderCell: (params: GridRenderCellParams<Date>) =>
        params.value ? (
          <Chip label="Active" color="primary" />
        ) : (
          <Chip label="Inactive" variant="outlined" />
        ),
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      headerClassName: "super-app-theme--header",
      sortable: false,
      width: 160,
      getActions: ({ row }) => renderMenus(row),
    },
  ];
  return (
    <>
      <DataTableDefault
        rowId={data.map((row) => row.ID_MOEDA)}
        data-testid="currencies-data-table"
        data={data}
        columns={columns}
        {...props}
      />
    </>
  );
}
